<template>
    <div>
        <SOSlotBase :bg-grey="false">
            <template v-slot:title-bar>
                <SOTitleBar :type="'back'" page-title="Riwayat Jadwal Dijalankan" @back="$router.go(-1)" />
            </template>
            <template v-slot:content>
                <div class="text-center f-c-midgrey py-4">
                    <div class="f-13 text-uppercase">
                        {{ penjadwalanDetail.masal_cron.jenis_periode == "monthly" ? "Bulanan" : "mingguan" }}
                    </div>
                    <div class="f-18 f-c-black f-bold">
                        {{ penjadwalanDetail.masal_cron.customer.nama}}
                    </div>
                    <div class="f-12">
                        {{ penjadwalanDetail.masal_cron.customer.telp}}
                    </div>
                </div>
                <div v-if="penjadwalanDetail.masal_cron_history.length">
                    <div class="bg-grey px-3 py-2">
                        <p class="m-0 f-c-midgrey f-16">{{penjadwalanDetail.masal_cron_history.length}} Kali Dijalankan</p>
                    </div>
                    <div class="p-3">
                        <div
                            v-for="(item, index) in penjadwalanDetail.masal_cron_history"
                            :key="index"
                            class=""
                        >
                            <div class="d-flex justify-content-between">
                                <div>
                                    <span class="f-semi f-16 pr-2">
                                        {{ $moment(item.created_at).format("dddd, DD MMM YYYY HH:mm") }}
                                    </span>
                                    <i class="fas fa-chevron-right f-c-midgrey"></i>
                                </div>
                                <div :class="item.status == 'failed' ? 'f-c-red' : 'f-c-green'">
                                    {{ item.status == "failed" ? "Gagal" : "Berhasil" }}
                                </div>
                            </div>
                            <div class="f-c-13 f-c-midgrey">
                                {{ item.status == 'success' ? item.idmasal_transaksi : item.status_info }}
                            </div>
                            <div
                                class="f-13 f-c-blue f-bold"
                                style="text-decoration: underline"
                                @click="handleHistory(item)"
                            >
                                {{ item.status == 'failed' ? '+ Buat Tagihan Masal' : 'Lihat Tagihan' }}
                            </div>
                            <div class="border-bottom my-3"/>
                        </div>
                    </div>
                </div>
                <div
                    v-else
                    class="border-top d-flex justify-content-center py-4 f-18 f-bold"
                >
                    <span>
                        Belum ada riwayat
                    </span>
                </div>
            </template>
        </SOSlotBase>
    </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import { moduleName } from "../store/state";

import SOSlotBase from "@/so-components/global/slot/SOSlotBase.vue";
import SOTitleBar from "@/so-components/global/ui/SOTitleBar.vue";

export default {
    name: 'penjadwalanRiwayat',
    components: {
        SOSlotBase,
        SOTitleBar,
    },
    props: {
        idcustomer: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            pageSetting: {
                isLoading: false
            },
        }
    },
    mounted() {
        console.log(this.idcustomer);
        this.getDetailPenjadwalan(this.idcustomer)
    },
    computed: {
        ...mapGetters(moduleName, {
            penjadwalanDetail: "penjadwalanDetail",
        }),
        ...mapGetters("filterGlobalModule", {
            filter: "getFilter",
            filterItem: "getFilterItem",
        }),
    },
    methods: {
        ...mapActions({
            getDetailPenjadwalan: `${moduleName}/getDetailPenjadwalan`
        }),
        async handleHistory(item) {
            if (item.status == 'success') {
                this.$router.push({ name: "invoice.detail", params: { invoiceId: item.idmasal_transaksi } }); 
            }
            else {
				console.log('item', item)
                const { masal_cron, masal_cron_history } = this.penjadwalanDetail
                this.$store.commit("filterGlobalModule/resetFilterItem");
                let filter = this.filterItem
                filter.oneOutlet = masal_cron.idoutlet
				filter.konsumen = [{
					id: masal_cron.customer.idcustomer,
					label: masal_cron.customer.nama,
				}]
                filter.periode.filterBy = 'periode'
                filter.periode.startDate = this.$moment(item.last_generated).format("YYYY-MM-DD")
                filter.periode.endDate = this.$moment(item.created_at).format("YYYY-MM-DD")
                this.$router.push({
                    name: "invoice.add",
                });
            }
        }
    }
}
</script>

<style scoped>
</style>